<template>
<div class="container">
    <div class="hill-section" id="meeting">
        <div class="columns">
            <div class="column is-6-desktop right-side">
                <h3 class="title">Mini Conference Room</h3>
                <div class="intro-text">
                    <p>Our meeting rooms, situated at prestigious locations with nice environment and are suitable for groups of up to 30 people, catering for:</p>
                    <p>
                        <span>Offsite executive strategy meetings</span>
                        <span>Presentations to corporate clients</span>
                        <span>Board meetings</span>
                        <span>Workshops</span>
                        <span>Special project meetings</span> 
                        <span>Conference Venue Hire</span>
                        <span>Training sessions</span>
                        <span>Design-thinking spaces</span>
                        <span>Brain-storming sessions</span>
                        <span>Other organizational gatherings</span>
                    </p>
                </div>
                    <div class="service-icon-group">
                        <div class="service-icon" v-for="icon in icons" :key="icon.id">
                            <span :class="icon.icn"></span>
                            <p>{{icon.label}}</p>
                        </div>
                    </div>
            </div>
            <div class="column is-6-desktop">
                <div class="slider-container slider">
                    <img src="../../public/image/meeting-room-1.jpg" alt="">
                    <img src="../../public/image/meeting-room-2.jpg" alt="">
                </div>
                <div class="prev icon-nearby-icon-10"></div>
                <div class="next icon-nearby-icon-09"></div>
            </div> 
        </div>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                icons:[
                    { icn:"hill-icon icon-nearby-icon-06", label:"Free Wifi" },
                    { icn:"hill-icon icon-nearby-icon-07", label:"Coffee Break" },
                    { icn:"hill-icon icon-nearby-icon-11", label:"Parking Space"}
                ]
            }
        },
        methods: {
            slider(){
                $(".slider").slick({
                    infinite: true,
                    nextArrow: $('.next'),
                    prevArrow: $('.prev'),
                    centerMode: true,
                })
            }
        },
        mounted(){
            this.slider();
        }
    }
</script>

<style lang="scss" scoped>
.columns{
    .column{
        position: relative;
        margin: 0;
        padding: 0;
        &.right-side{
            position: relative;
            padding: 20px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .title{
                color: $color-sub;
                margin-bottom: 10px;
            }
            .intro-text{
                margin-bottom: 20px;
                p{
                    &:not(:first-child){
                        margin-top: 20px;
                    }
                    span{
                        font-size: 14px;
                        border-right: 1px solid $color-main;
                        padding: 0 10px;
                        // background-color: rgba($color: $color-sub, $alpha: 0.9);
                    }
                }
            }
        }
    }
}

.next, .prev{
    position: absolute;
    cursor: pointer;
    color: #fff;
    border-radius: 50%;
    z-index: 1;
    top: 45%;
    font-size: 40px;
    background-color: rgba($color: $color-sub, $alpha: 0.9);
    &:hover{
        background-color: rgba($color: $color-sub, $alpha: 1);
    }
}
.next{
    right: 10px;
}
.prev{
    left: 10px;
}
        
.service-icon-group{
    display: flex;
    justify-content: center;
    .service-icon{
        margin-top: 20px;
        background-color: rgba($color: $color-sub, $alpha: 0.3);
        padding: 10px;
        border-radius: 5px;
        margin: 5px;
        font-size: 14px;
        @include mobile{
            margin: 5px;
        }
        .hill-icon{
            color: $color-main;
            font-size: 80px;
        }
        p{
            color: $color-main;
            @include mobile{
                white-space: pre;
                font-size: 12px;
            }
        }
    }
}

</style>